"use strict";
/**
 * @module "ethpm/registries"
 */
Object.defineProperty(exports, "__esModule", { value: true });
